export default __webpack_public_path__ + "static/media/audiomack-sqr.fb8eea1c.svg";